import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import ReactTable from 'components/common/ReactTable';
import { useForm, Controller } from 'react-hook-form';
import SearchableDropdown from 'components/common/SearchableDropdown';
import ReactDatePicker from 'components/common/ReactDatePicker';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import './report.css'
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { getlocation } from 'services/manageEventsService'
import { guestvisitreportlist } from 'services/reportsService'
import { loaderContext } from 'context/Context';
import moment from 'moment';
import { getListOfregister } from 'services/adminmoduleService'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Modal } from 'react-bootstrap';




function GuestVisitReport() {

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const { isLoading, setIsLoading } = useContext(loaderContext)

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [guestvisitdata, setGuestVisitData] = useState([]);

    const [locationOption, setLocationOption] = useState([]);
    const [registerbyOption, setRegisterByOption] = useState([]);
    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [isOpen, setIsOpen] = useState(false)
    const [viewVisitData, setViewVisitData] = useState([])
    // const [profilePhoto, setProfilePhoto] = useState([])
    const [frontDocPhoto, setFrontDocPhoto] = useState([])
    const [backDocPhoto, setBackDocPhoto] = useState([])




    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();

    useEffect(async () => {
        checkModulePermission("Guest Visit Report")
        setIsLoading(true)

        try {
            const { data } = await getlocation()
            const { data: guestvisit } = await guestvisitreportlist({})
            const { data: register } = await getListOfregister()
            setLocationOption(data?.data?.map((loc) => ({ label: loc?.name, value: loc?.id })))
            setRegisterByOption(register?.data?.filter((reg) => reg.role == 5).map((regis) => ({ label: regis?.name, value: regis?.id })))
            setGuestVisitData(guestvisit?.data)
        } catch (error) {
            errorMessage(error)
        }
        setIsLoading(false)

    }, [])
    console.log("viewvisitdat=-=====>", viewVisitData)

    useEffect(() => {
        // setProfilePhoto(viewVisitData?.profile_photo ? `data:image/jpeg;base64,${viewVisitData?.profile_photo}` : "")
        setFrontDocPhoto(viewVisitData?.front ? `data:image/jpeg;base64,${viewVisitData?.front}` : "")
        setBackDocPhoto(viewVisitData?.back ? `data:image/jpeg;base64,${viewVisitData?.back}` : "")
    }, [viewVisitData])

    const handleOpenModal = (id) => {
        setIsOpen(true)
        const viewData = guestvisitdata?.find((guest) => guest.id === id)
        setViewVisitData(viewData)
    }
    const handleCloseModal = () => {
        setIsOpen(false)
    }

    const columns = [

        {
            Header: t('guestvisitreport.guestvisitreporttable.guestname'),
            accessor: 'name',
            Cell: ({ row }) => {
                return row?.original?.name ? row?.original?.name : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.membername'),
            accessor: 'member_name',
            Cell: ({ row }) => {
                return row?.original?.member_name ? row?.original?.member_name : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.memberno'),
            accessor: 'member_number',
            Cell: ({ row }) => {
                return row?.original?.member_number ? row?.original?.member_number : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.location'),
            accessor: 'location',
            Cell: ({ row }) => {
                return row?.original?.location ? row?.original?.location : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.vehicleregno'),
            accessor: 'vehicle_reg_no',
            Cell: ({ row }) => {
                return row?.original?.vehicle_reg_no ? row?.original?.vehicle_reg_no : '--'
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.timein'),
            accessor: 'time_in',
            Cell: ({ row }) => {
                return row?.original?.time_in ? moment(row?.original?.time_in).format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.timeout'),
            accessor: 'time_out',
            Cell: ({ row }) => {
                return row?.original?.time_out ? moment(row?.original?.time_out).format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.duration'),
            accessor: 'duration',
            Cell: ({ row }) => {
                return row?.original?.duration ? row?.original?.duration : "--"
            }
        },
        {
            Header: t('guestvisitreport.guestvisitreporttable.action'),
            Cell: ({ row }) => (
                <div>
                    <span
                        className="btn p-0 me-2"
                        title="View"
                        onClick={() => handleOpenModal(row.original.id)}
                    >
                        <VisibilityIcon />
                    </span>
                </div>
            ),
            disableSortBy: true
        }
    ];

    const onSubmit = async (guestvisitdata) => {
        console.log(guestvisitdata);
        setIsLoading(true)

        if (guestvisitdata?.location_id || guestvisitdata?.vehicle_reg_no || guestvisitdata?.register_by || (startDate && endDate)) {
            try {
                guestvisitdata.location_id = guestvisitdata.location_id?.value
                guestvisitdata.register_by = guestvisitdata.register_by?.value
                if (startDate && endDate) {
                    guestvisitdata.date_range = `${moment(startDate).format(process.env.REACT_APP_FILTER_DATE)}-${moment(endDate).format(process.env.REACT_APP_FILTER_DATE)}`;
                }
                const { data } = await guestvisitreportlist(guestvisitdata)
                setGuestVisitData(data?.data)
            } catch (e) {
                if (e.response.data) {
                    if (Array.isArray(e.response.data.message)) {
                        e.response.data.message.map(errors => toast.error(errors, toastConfig))
                    } else {
                        toast.error(e.response.data.message, toastConfig)
                    }
                } else {
                    toast.error(e.message, toastConfig)
                }
            }
        }
        setIsLoading(false)

    };

    const downloadPDF = () => {
        const docDefinition = {
            pageOrientation: 'landscape',
            pageSize: { width: 700, height: 600 },
            content: [
                { text: 'User Data', style: 'header' },
                { text: '\n' },
                {
                    table: {
                        headerRows: 1,
                        widths: Array.from({ length: columns.length }, () => 'auto'),
                        body: [
                            columns.map((column) => column.Header),
                            ...guestvisitdata.map((row) => columns.map((column) => {
                                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                                    return row[column.accessor] && row[column.accessor] != "" ? moment(row[column.accessor]).format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--';
                                } else {
                                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                                }
                            })),
                        ],
                    },
                },
            ],
            defaultStyle: {
                actionHeader: false,
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                },
            },
        };

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download('guestvisit_data.pdf');
    };

    const downloadCSV = () => {
        const csvData = [
            columns.map((column) => column.Header),
            ...guestvisitdata.map((row) => columns.map((column) => {
                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                    return row[column.accessor] && row[column.accessor] != "" ? moment(row[column.accessor]).format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--';
                } else {
                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                }
            })),
        ]
            .map((row) => row.join(','))
            .join('\n');

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'guestvisit_data.csv');
    };


    return (
        <div className="row g-3 mb-3">
            {/* <div className=""> */}
            <div className="card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-9 data-table" style={{ height: "fit-content" }}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-4 heading-text">
                            <h3 className="heading-color fw-600 mb-0">
                                {t('guestvisitreport.heading')}
                            </h3>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-8 table-btn" >
                            <button
                                className="btn btn-primary btn-sm float-end"
                                onClick={() => downloadPDF()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('guestvisitreport.exportpdfbtn')}
                                </span>
                            </button>

                            <button
                                className="btn mx-1 btn-primary btn-sm float-end"
                                onClick={() => downloadCSV()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('guestvisitreport.exportcsvbtn')}
                                </span>
                            </button>
                        </div>

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ReactTable
                        columns={columns}
                        data={guestvisitdata}
                        pageSizeOption={[5, 10, 15, 20]}
                        headerClass="btn-primary"
                        isSearchBoxVisible
                        widthClass="table-width"
                        ispaginationvisible={true}
                    />
                </div>
            </div>


            <div className='card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-2 filter-table' style={{ padding: "0rem .8rem 0rem .8rem", height: "fit-content" }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row' style={{ backgroundColor: "rgb(247, 247, 247)", paddingTop: ".8rem", height: "3rem", color: "black", marginBottom: '1rem' }}>
                        <span>{t('guestvisitreport.filterheading')}</span>
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('guestvisitreport.filterform.location')}
                        </label>
                        <Controller
                            name="location_id"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={locationOption}
                                    hasError={errors.location}
                                // placeholder={t('guestsummaryreport.placeholder.idtype')}
                                />
                            )}
                        />
                        {/* {errors.location && (
                            <small>
                                {errors.location.type === 'required' && (
                                    <span className="text-danger">
                                        {t('guestvisitreport.error.location')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('guestvisitreport.filterform.registeredby')}
                        </label>
                        <Controller
                            name="register_by"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={registerbyOption}
                                    hasError={errors.registered_by}
                                // placeholder={t('guestsummaryreport.placeholder.idtype')}
                                />
                            )}
                        />
                        {/* {errors.register_by && (
                            <small>
                                {errors.register_by.type === 'required' && (
                                    <span className="text-danger">
                                        {t('guestvisitreport.error.registerby')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label className="form-label">
                            {t('guestvisitreport.filterform.vehicleregno')}
                            {/* <span className="text-danger ms-1">*</span> */}
                        </label>
                        <input
                            type='text'
                            className={`form-control ${errors.vehicle_reg_no && 'is-invalid'
                                }`}
                            placeholder={t('guestvisitreport.filterform.vehicleregno')}
                            {...register('vehicle_reg_no')}
                        />
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('guestvisitreport.filterform.date')}
                        </label>
                        <Controller
                            name="date_range"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <>
                                    {/* <ReactDatePicker
                                    value={value}
                                    // onChange={onChange}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    placeholder={t(
                                        'guestvisitreport.placeholder.date'
                                    )}
                                    hasErrors={errors.date_range}
                                    dateFormat="dd-MM-yyyy"
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                // isClearable={true}
                                /> */}

                                    <ReactDatePicker
                                        selected={startDate}
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder={t('summaryreport.placeholder.startdate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        maxDate={endDate || undefined}
                                    />
                                    {/* <span className="mx-2">-</span> */}
                                    <br />
                                    <ReactDatePicker
                                        selected={endDate}
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder={t('summaryreport.placeholder.enddate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate || undefined}
                                    />
                                </>
                            )}
                        />
                        {/* {errors.date && (
                            <small>
                                {errors.date.type === 'required' && (
                                    <span className="text-danger">
                                        {t('guestvisitreport.error.daterange')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="text-start col-12">
                        <div className="mb-3 mt-4 text-start">
                            <button type="submit" className="col-lg-12 btn btn-primary me-1">
                                {t('guestvisitreport.filterform.filterbtn')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/* </div> */}

            {isOpen && (
                <Modal show={isOpen} onHide={handleCloseModal}>
                    <Modal.Header className="heading-color-frontdesk fw-600 guestregistermodalheader" >{t('guestvisitreport.modalheading')}
                        <i closeButton className="fa  fa-times-circle modal-close-btn" aria-hidden="true" onClick={handleCloseModal}></i>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <p style={{ fontWeight: "bold" }}>{viewVisitData?.doc_id_type_name}</p>
                        </div>

                        <div className="d-flex justify-content-around">
                            {/* <img src={`${profilePhoto != "" ? profilePhoto : `${process.env.REACT_APP_BASEROUTE_URL}/admin-images/user.png`}`} alt="Document 1" className="img-fluid" style={{ objectFit: "contain", aspectRatio: "auto" }} /> */}
                            <img src={`${frontDocPhoto != "" ? frontDocPhoto : `${process.env.REACT_APP_BASEROUTE_URL}/admin-images/scanner.png`}`} alt="Document 1" style={{ objectFit: "contain", aspectRatio: "auto", maxWidth: "40%" }} />
                            <img src={`${backDocPhoto != "" ? backDocPhoto : `${process.env.REACT_APP_BASEROUTE_URL}/admin-images/scanner.png`}`} alt="Document 2" style={{ objectFit: "contain", aspectRatio: "auto", maxWidth: "40%" }} />
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </div>

    )
}

export default GuestVisitReport